import { render } from "./PiedePagina.vue?vue&type=template&id=e05f7c38&scoped=true"
import script from "./PiedePagina.vue?vue&type=script&lang=js"
export * from "./PiedePagina.vue?vue&type=script&lang=js"

import "./PiedePagina.vue?vue&type=style&index=0&id=e05f7c38&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e05f7c38"]])

export default __exports__